const initialState = {
    arr: []
}

const docArrayReducer = (state = initialState, action) => {
    switch(action.type){
        case 'DOC_ARRAY' : {
            return {
                ...state,
                arr: action.arr
            }
        }
        default: {
            return state
        }
    }
}

export default docArrayReducer